// صفحة مهام جمانا - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const JumanaTasks = () => (
  <EmployeeTasksPage employeeName="جمانا" title="جمانا" backPath="/Jumana" />
);

export default JumanaTasks;
